// extracted by mini-css-extract-plugin
export default {"organisationSelect":"OrganisationSelect_organisationSelect__shEUb"};